import React, { Component } from 'react';

class RankingBar extends Component{

  getColors() {
    const { campaign } = this.props
    return campaign.template && campaign.template.appearence && campaign.template.appearence.colors
  }

  filledWith(){
    const {
      ranking,
      multiplier,
      campaign
    } = this.props
    const colors = this.getColors()
    const style = {}
    const height_prev = 28 + 5 * multiplier

    const percentil = 100 / 22 * multiplier
    if (ranking.percentil > percentil){
      style.background = `linear-gradient(${colors && colors["brand-default"]} 0%, 4%, ${colors && colors["brand-hover"]} 7%)`
    }
    if (this.getPosition()){
      style.borderRadius = '0 0 2px 2px'
    }
    style.height =  height_prev + 'px'
    return style
  }


  getPosition(){
    const { 
      ranking,
      multiplier
    } = this.props

    const percentil = 100 / 22 * multiplier
    const percentil_plus = 100 / 22 * (multiplier +1)
    
    return ranking.percentil > percentil && ranking.percentil <= percentil_plus
  }

  bubbleStyle(){
    const colors = this.getColors()
    return {
      background: `linear-gradient(115deg, ${colors && colors["brand-default"]} 0%, 30%, ${colors && colors["brand-hover"]} 70%)`,
      border: `5px solid ${colors && colors["brand-hover"]}`
    }
  }

  render(){
    const {
      ranking
    } = this.props
    const colors = this.getColors()
    return(
      <div>
        {this.getPosition() ?
          <div className='relative'>
          <div style={this.bubbleStyle()} className='ranking-position'>{ranking.position}<span className='ranking-position-span'>º</span></div>
          <div className='ranking-pointer' style={{background: colors && colors["brand-default"]}}></div>
          </div>
        : null
        }
        <div style={this.filledWith()}className='ranking-vertical'>
        </div>
      </div>
    )
  }
}

export default RankingBar;